/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_EmptyInputs */



/**
* | output |
* | --- |
* | "No templates yet. Save a project as a template to reuse its setup." |
*
* @param {Templates_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const templates_empty = /** @type {((inputs?: Templates_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Vorlagen. Speichere ein Projekt als Vorlage, um seine Konfiguration wiederzuverwenden.")
	return /** @type {LocalizedString} */ ("No templates yet. Save a project as a template to reuse its setup.")
});